import {
    ATTACHMENT_ENTITY_TYPES,
    getAttachmentEntityConfig,
} from '../../general_components/attachmentsPopup/attachmentEntityConfig';
import { openAttachmentsPopup } from '../../general_components/attachmentsPopup/attachmentsPopup';

export const PAYABLE_INVOICE_ATTACHMENTS_POPUP_KIND =
    getAttachmentEntityConfig(ATTACHMENT_ENTITY_TYPES.PAYABLE_INVOICE).popupKind;

export function openPayableInvoiceAttachmentsPopup({ invoice, canEdit, onInvoiceUpdated }) {
    openAttachmentsPopup({
        entityType: ATTACHMENT_ENTITY_TYPES.PAYABLE_INVOICE,
        entity: invoice,
        titleLabel: invoice?.invoiceNumber != null ? String(invoice.invoiceNumber) : '',
        canEdit,
        onEntityUpdated: onInvoiceUpdated,
        popupKind: PAYABLE_INVOICE_ATTACHMENTS_POPUP_KIND,
    });
}
